(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial"] && !Shopify.designMode) return;
  try {
    
class TestimonialCarousel {
  constructor(container) {
    this.container = container;
    this.carousel = container.querySelector('.testimonial-lists');
    this.cards = Array.from(this.carousel.querySelectorAll('.testimonial-list-item'));
    this.prevButton = container.querySelector('.carousel-arrow.prev');
    this.nextButton = container.querySelector('.carousel-arrow.next');
    this.currentIndex = 0;
    this.cardsPerView = this.getCardsPerView();
    this.totalCards = this.cards.length;
    
    if (this.totalCards === 0) return;
    
    // Set initial position and arrow visibility
    this.updateCarousel();
    
    // Event listeners
    this.prevButton?.addEventListener('click', () => this.scroll('prev'));
    this.nextButton?.addEventListener('click', () => this.scroll('next'));
    
    // Handle window resize
    window.addEventListener('resize', () => {
      this.cardsPerView = this.getCardsPerView();
      this.updateCarousel();
    });
  }
  
  getCardsPerView() {
    if (window.innerWidth <= 685) {
      return 1;
    } else if (window.innerWidth <= 1091) {
      return 2;
    }
    return 3;
  }
  
  scroll(direction) {
    if (direction === 'next') {
      this.currentIndex++;
    } else {
      this.currentIndex--;
    }
    
    this.updateCarousel();
  }
  
  updateCarousel() {
    // Calculate how many cards we can scroll
    const maxScroll = Math.max(0, this.totalCards - this.cardsPerView);
    
    // Clamp currentIndex to valid range
    this.currentIndex = Math.max(0, Math.min(this.currentIndex, maxScroll));
    
    // Calculate card width including margin
    const cardElement = this.cards[0];
    const cardWidth = cardElement.offsetWidth;
    // Use 20px margin for mobile (sub-599px), 50px for larger screens
    const margin = window.innerWidth <= 599 ? 20 : 50;
    const cardWithMargin = cardWidth + margin;
    
    // Apply transform
    const offset = -this.currentIndex * cardWithMargin;
    this.carousel.style.transform = `translateX(${offset}px)`;
    
    // Update arrow visibility
    this.updateArrows();
  }
  
  updateArrows() {
    const maxScroll = Math.max(0, this.totalCards - this.cardsPerView);
    
    // If there are 3 or fewer cards, hide both arrows
    if (this.totalCards <= this.cardsPerView) {
      this.prevButton?.classList.add('disabled');
      this.nextButton?.classList.add('disabled');
      return;
    }
    
    // Show/hide left arrow
    if (this.currentIndex === 0) {
      this.prevButton?.classList.add('disabled');
    } else {
      this.prevButton?.classList.remove('disabled');
    }
    
    // Show/hide right arrow
    if (this.currentIndex >= maxScroll) {
      this.nextButton?.classList.add('disabled');
    } else {
      this.nextButton?.classList.remove('disabled');
    }
  }
}

// Initialize carousel when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  const containers = document.querySelectorAll('.testimonial-carousel-container');
  containers.forEach(container => {
    new TestimonialCarousel(container);
  });
});

  } catch(e) { console.error(e); }
})();
})();
